export default {
  primary: '#464653',
  secondary: '#FF6720',
  error: '#DE0000',
  link: '#009CDE',
  success: '#1EBC62',

  white: '#fff',
  black: '#000',

  red: {
    '500': '#DE0000',
    '100': '#FCEAE9',
  },

  brand: {
    '800' : '#FF6720',
    '700' : '#FC8D5D',
    '600' : '#FBB193',
    '500' : '#F8D3C5',
    '400' : '#F7DBCF',
    '300' : '#F7E2D9',
    '200' : '#FFF0E9',
    '100' : '#F6EFEB',
  },

  yellow: {
    '800' : '#FFA300',
    '700' : '#FCB84A',
    '600' : '#FBCC86',
    '500' : '#F8E1BF',
    '400' : '#F7E4CA',
    '300' : '#F7EAD6',
    '200' : '#FFF6E6',
    '100' : '#F6F1EA',
  },

  seafoam: {
    '800' : '#00B398',
    '700' : '#48C4B0',
    '600' : '#86D4C7',
    '500' : '#C0E5DE',
    '400' : '#CAE8E2',
    '300' : '#D6EBE8',
    '200' : '#E6F7F5',
    '100' : '#EBF1F0',
  },

  blue: {
    '700': '#253746',
    '500': '#009CDE',
    '400': '#7AC2EB',
    '300': '#D1E2FA',
    '200': '#D3EBF8',
    '100': '#E6F5FC',
  },

  mauve: {
    '300': '#758BF2',
    '200': '#F5ECF8',
    '100': '#E3E8FC',
  },

  purple: {
    '800' : '#963CBD',
    '700' : '#AF70CB',
    '600' : '#C79EDA',
    '500' : '#DFCAE7',
    '400' : '#E3D3EA',
    '300' : '#E8DCED',
    '200' : '#ECE4EF',
    '100' : '#F1ECF2',
  },

  gray: {
    '800': '#2D3748',
    '700': '#464653',
    '600': '#525260',
    '500': '#787885',
    '400': '#AAAAB4',
    '300': '#EBEBF1',
    '200': '#F5F5F8',
    '100': '#FAFAFC',
  },
};
